module.exports = __webpack_public_path__ + "img/agreement-logo.262750a2.png";